export interface Module {
  num: number
  title: string
  intro: string[]
  chips?: string[]
  highlight?: string
  outro?: string[]
}

export const modules: Module[] = [
  {
    num: 1,
    title: 'READY-TO-TEACH LESSON LIBRARY™',
    intro: [
      'Una libreria strutturata di lezioni complete pronte da utilizzare, organizzate per livello, obiettivo e argomento.',
      'Troverai lezioni dedicate a situazioni quotidiane, lavoro, viaggi, comunicazione, tecnologia, cultura, relazioni, salute, educazione, tempo libero e molti altri contesti utili.',
      'Ogni lezione integra gli elementi necessari per costruire una sequenza coerente: obiettivo, warm-up, introduzione, target language, vocabolario, pratica guidata, attività principale, produzione, consolidamento e follow-up.',
    ],
    outro: ['Scegli la lezione più adatta e parti da una struttura già pronta.'],
  },
  {
    num: 2,
    title: 'GRAMMAR & VOCABULARY TEACHING TOOLKIT™',
    intro: [
      'Un toolkit pratico per lavorare sui principali elementi grammaticali e lessicali attraverso materiale già strutturato.',
    ],
    chips: [
      'Tempi verbali.',
      'Domande.',
      'Modali.',
      'Conditionals.',
      'Passive voice.',
      'Reported speech.',
      'Preposizioni.',
      'Phrasal verbs.',
      'Collocations.',
      'Functional language.',
      'Vocabolario tematico.',
      'E molto altro.',
    ],
    outro: [
      'Non soltanto spiegazioni.',
      'Troverai esempi, esercizi, pratica contestualizzata, attività di correzione, applicazione comunicativa e soluzioni quando necessario.',
    ],
  },
  {
    num: 3,
    title: 'SPEAKING & COMMUNICATION ACTIVITY VAULT™',
    intro: [
      'Una libreria creata per una delle parti più importanti di qualsiasi lezione di inglese:',
    ],
    highlight: 'far parlare realmente gli studenti.',
    chips: [
      'Conversation prompts.',
      'Role plays.',
      'Discussion activities.',
      'Information gaps.',
      'Pair work.',
      'Debates.',
      'Problem solving.',
      'Storytelling.',
      'Situational English.',
      'Fluency challenges.',
    ],
    outro: [
      'Attività organizzate per livello, obiettivo e durata per aiutarti a trovare rapidamente qualcosa di adatto alla tua lezione.',
      'Dalle attività rapide di pochi minuti fino a sessioni comunicative più complete.',
    ],
  },
  {
    num: 4,
    title: 'READING, WRITING & LANGUAGE SKILLS LIBRARY™',
    intro: [
      'Materiale strutturato per sviluppare le principali competenze linguistiche attraverso attività concrete.',
      'Reading con testi originali graduati, comprensione, vocabulary in context, interpretazione, discussione ed esercizi di estensione.',
      'Writing con email, messaggi, descrizioni, storie, recensioni, opinioni, report e attività formali e informali.',
      'In più, strumenti dedicati alla pronunciation e al functional language.',
    ],
    outro: [
      'Una libreria pronta per lavorare sulle competenze in modo più organizzato e progressivo.',
    ],
  },
  {
    num: 5,
    title: 'GAMES, ACTIVITIES & CLASSROOM ENGAGEMENT SYSTEM™',
    intro: [
      'Una raccolta professionale di attività progettate per rendere la lezione più dinamica senza perdere l’obiettivo linguistico.',
    ],
    chips: [
      'Vocabulary games.',
      'Grammar activities.',
      'Speaking challenges.',
      'Guessing activities.',
      'Team challenges.',
      'Error hunts.',
      'Storytelling.',
      'Review games.',
      'Warm-ups.',
      'Lesson closers.',
      'Fast finisher activities.',
      'No-prep activities.',
      'Emergency activities.',
    ],
    outro: [
      'Quando hai bisogno di cambiare ritmo, consolidare un argomento o riempire in modo utile gli ultimi minuti della lezione, avrai qualcosa di concreto da utilizzare.',
    ],
  },
  {
    num: 6,
    title: 'ASSESSMENT, REVIEW & LESSON PLANNING SYSTEM™',
    intro: [
      'La parte che collega tutto il sistema.',
      'Strumenti per verificare conoscenze e progressi, organizzare review, costruire lezioni e pianificare sequenze di lavoro.',
      'Include attività diagnostiche, language checks, skills assessments, progress reviews, rubriche, strumenti di feedback e strutture di pianificazione.',
      'Inoltre avrai un Lesson Builder System per costruire rapidamente una lezione partendo da:',
    ],
    highlight:
      'Level → Objective → Language Focus → Warm-Up → Practice → Main Activity → Production → Review → Homework',
    outro: ['Con strutture pronte per lezioni da 30, 45, 60 e 90 minuti.'],
  },
]
